import apiClient from "./apiClient";

// ✅ Fetch affiliate signups (from the landing site's /affiliate-program) with pagination + search
export const fetchAffiliatesAPI = ({ page = 1, perPage = 20, search = "" } = {}) => {
  return apiClient.get(`/tailmission/api/v1/admin/affiliates`, {
    params: { page, per_page: perPage, ...(search ? { search } : {}) },
  });
};
